<template>
    <div class="code-lab" :class="{'has-header': hasHeader}">
        <template v-if="hasHeader">
            <header-tool v-if="currentVersion === 'public'" />
            <template v-if="isSocketInited" >
                <left-side v-if="!leftSideHide" :class="['left-side']" />
                <div class="codelab-content" :style="{width: leftSideHide ? '100%' : 'calc(100% - 65px)'}">
                    <tool-bar v-show="showToolBar"></tool-bar>
                    <code-blockly :style="{width: showSimulator ? `calc(100% - ${wt}px - ${(selectedMenue === 'program' ? 150 : 0)}px)` : `calc(100% - ${(selectedMenue === 'program' ? 150 : 0)}px)`,height: 'calc(100% - '+(showToolBar ? 46 : 0)+'px)'}" :toolbox="toolbox" v-if="showCodeBlockly"></code-blockly>
                    <simulator-area @simulatorUiEvent="simulatorUiState = true" class="simulator-area" :style="{width: showSimulator ? `calc(${wt}px + 32px)` : '32px'}"></simulator-area>
                </div>
            </template>
            
            <template v-if="selectedMenue === 'mission' && hasTaskRouteVersion.includes(currentVersion)">
                <router-view />
            </template>

            <template v-if="selectedMenue === 'program'">
                <file-management :class="[ 'program-area', shit$(`left:${64 + 150}px; w:calc(100% - ${64 + 150}px); pt:19px; pl:18px; pr:27px; `) ]" />
            </template>

            <template>
              <s-import />
              <s-notify />
              <s-message />
              <mission-details-wrapper />
              <dialo-tip-wrapper v-if="daloTipStore$.switch" />
              <missionProcess />
              <Intro />
            </template>
        </template>
        <template v-else>
            <router-view />
        </template>
         <account-info v-if="currentVersion === 'student' && showAccountInfo" :visible.sync="showAccountInfo"></account-info>
    </div>
</template>

<script>
import simulatorArea from "@/code-lab/component/layout/simulator-area.vue";

import toolBar from "./component/layout/toolbar.vue";
import leftSide from "@/code-lab/component/layout/left-side-bar.vue";

import codeBlockly from "@/code-lab/component/layout/code-blockly.vue";
import HeaderTool from "@/code-lab/component/layout/header.vue";
import FileManagement from "@/code-lab/component/file-management/file-management.vue";
import SImport from "@/code-lab/view/organization/s-import.js";
import SNotify from "@/code-lab/view/organization/s-notify.vue";
import SMessage from "@/code-lab/view/organization/s-message.vue"

import MissionDetailsWrapper from "@/code-lab/component/mission/mission-details-wrapper.vue";
import DialoTipWrapper from "@/code-lab/view/dialo-tip-wrapper/wrapper.vue";
import accountInfo from '@/code-lab/component/account-info.vue'
import missionProcess from "@/code-lab/component/mission/mission-process.vue";
import IndexMixGroceryStore from "@/code-lab/component/mixins/indexMixStore.js";
import { store as daloTipStore } from "@/code-lab/view/dialo-tip-wrapper/observable.js";
import { store as exchangeStore, mutations as exchangeutations } from "@/code-lab/component/exchange/observable.js";
import Intro from '@/code-lab/component/intro/intro.vue'
import { mapMutations, mapState } from "vuex";
const Blockly = window.Blockly;
const Cookies = window.Cookies;
const CONSTS = window.CONSTS
const interceptHandle = (name, lang) => {
  const arr = [ { name: 'task', lang: ['ja', 'en'], redirect: '/' } ]
  return arr.find(fd => fd.name === name && fd.lang.includes(lang))
}
export default {
  name: "code-lab",
  mixins: [IndexMixGroceryStore],
  components: {
    leftSide,
    toolBar,
    codeBlockly,
    simulatorArea,
    HeaderTool,
    FileManagement,
    SImport,
    SNotify,
    SMessage,
    MissionDetailsWrapper,
    DialoTipWrapper,
    missionProcess,
    Intro,
    accountInfo
  },
  beforeRouteEnter (to, from, next) {
    const trg = interceptHandle(to.name, Cookies.get("langCode"))
    trg ? next({ path: trg.redirect }) : next()
  },
  beforeRouteUpdate (to, from, next) {
    const trg = interceptHandle(to.name, Cookies.get("langCode"))
    if (!trg && this.hasTaskRouteVersion.includes(this.currentVersion)) {
        const flag = [from.name === "codeLab", !this.isSaved, this.isAllowSave, !this.selectedMenue].every(ev => ev)
        flag ? this.showUnsavedTips(6)
            .then(() => {
              let script = Blockly.Xml.textToDom(CONSTS.EMPTY_WORK_SPACE);
              Blockly.Xml.hardDomToWorkspace(script, this.workSpace);
              this.$store.commit("UPDATE_PROJECT_DATA", {
                name: this.$t("UNNAMEDPROJECT"),
                projectId: null,
                script: null
              });
              this.$store.commit("UPDATE_IS_SAVED", true);
              next();
            })
            .catch(() => {
              next({ name: from.name });
            })
        : next();
    } else {
      trg ? next({ path: trg.redirect }) : next()
    }
  },
  data () {
    return {
      currentRoute: "",
      showCodeBlockly: false,
      toolbox: null,
      hasTaskRouteVersion: ["public", "family"],
      resizeTimer: null,
      wt: 350,
      simulatorUiState: false,
      showAccountInfo: false
    };
  },
  computed: {
    ...mapState({
      projectData: "projectData",
      isAllowSave: "isAllowSave",
      isSaved: "isSaved",
      langCode: "langCode",
      currentMission: "currentMission",
      projectId: state => state.projectData.projectId,
      selectedMenue: "selectedMenue",
      showMissionList: "showMissionList",
      currentVersion: "currentVersion",
      toolBarHide() {
        return this.computedToolBarHide();
      },
      leftSideHide() {
        return this.computedLeftSideHide();
      },
      showSimulator: "showSimulator" 
    }),
    isSocketInited() {
      // this.b$.send('quick', {
      //   cmd: 'get_mc_info',
      //   data: {}
      // })
      return this.$root.isSocketInited;
    },
    showToolBar() {
      return !this.toolBarHide && !this.showMissionList;
    },
    showSimulatorCondition () {
        return this.isSocketInited && this.simulatorUiState
    },
    hasHeader(){
        return !['exchange', 'guide'].includes(this.selectedMenue)
    }
  },
  watch: {
    showSimulatorCondition (allow) {
       allow && this.$nextTick(() => this.$store.commit("SHOW_SIMULATOR", true))
    },
    isSocketInited(isSocket) {
      isSocket && this.currentRoute === "task" && this.$store.commit("SELECTEDMENUERIGHT", "mission");
      // this.$nextTick(() => this.$store.commit("SHOW_SIMULATOR", isSocket))
    },
    $route: {
      immediate: true,
      handler(to) {
        if (this.hasTaskRouteVersion.includes(this.currentVersion)) {
          if (to.name === "task") {
            Object.assign(this, { currentRoute: to.name });
            return (
              this.isSocketInited &&
              this.$store.commit("SELECTEDMENUERIGHT", "mission")
            );
          } else if (to.name === "exchange") {
            if (!exchangeutations.allowedUse(exchangeStore.type)) {
              return this.$router.push({ path: "/" });
            }
          } else if (to.name === "guide") {
            if (!this.isPublic()) return this.$router.push({ path: "/" });
            this.$store.commit("SELECTEDMENUERIGHT", "guide");
            
          } else {
            if (this.selectedMenue === "program") return;
            this.$store.commit("SELECTEDMENUERIGHT", null);
          }
        }
      }
    },
    selectedMenue (newVal) {
      newVal && this.$store.commit("SET_CURRENT_MISSION", null);
      if (this.hasTaskRouteVersion.includes(this.currentVersion)) {
        if (newVal) {
          this.$store.commit("isCloudProject", false);
        } 
        if (newVal === "mission") {
          if (this.$route.name === "task") return;
          this.$router.push({ path: `/task` });
        } else if (newVal === "program") {
          if (this.$route.name === "codeLab") return;
          this.$router.push({ name: "codeLab" });
        } else if (newVal === "exchange") {
          
          if (this.$route.name === "exchange") return;
          this.$router.push({ path: `/exchange` });
        } else if (newVal === "guide") {
          if (this.$route.name === "guide") return;
          this.$router.push({ path: `/guide` });
        } else {
          if (this.$route.name === "codeLab") return;
          this.$router.push({ path: "/" });
        }
      }
    },
    langCode: {
      handler(langCode) {
        this.updateBlocklyMsg(langCode);
        this.updateToolBoxXml();
      }
    },
  },
  created () {
    this.daloTipStore$ = daloTipStore;
    this.updateBlocklyMsg(this.langCode);
    this.updateToolBoxXml(this.langCode);
  },
  mounted () {
    window.addEventListener('resize', this.onResize)
    this.confirmWidth()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
      ...mapMutations('user', {
          updateUserInfo: 'updateUserInfo'
      }),
    confirmWidth () {
      this.wt = document.documentElement.clientWidth > 1250 ? 350 : 300
    },
    onResize () {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer)
        this.resizeTimer = null
      }
      this.resizeTimer = setTimeout(() => {
        this.confirmWidth()
        this.workSpace && this.$nextTick(() => Blockly.svgResize(this.workSpace))
      }, 200)
    },
    isPublic() {
      return this.currentVersion === "public";
    },
    computedToolBarHide() {
      const mappingVersion = { public: 0, student: 0, family: 0, teacher: 0 };
      const mappingMenue = { program: 1, mission: 0 };
      const versionHide = !!mappingVersion[this.currentVersion];
      const controlMenueHide = !!mappingMenue[this.selectedMenue];
      return versionHide || controlMenueHide;
    },
    computedLeftSideHide() {
      const mapping = { public: 0, student: 0, family: 0, teacher: 0 };
      return !!mapping[this.currentVersion];
    },
    haloChild(msg) {
      this.langCode = msg;
    },
    updateToolBoxXml() {
      this.loadToolBoxXml()
        .then(toolbox => {
          window.nuwa_blockly_toolbox = toolbox;
          this.toolbox = toolbox;
          this.showCodeBlockly = true;
        })
        .catch(() => {
          this.showCodeBlockly = false;
        });
    },
    
    updateBlocklyMsg(langCode) {
      let blocklyMsg = this.$i18n.messages[langCode].blockly_msg || {};
      Blockly.Msg = Object.assign(Blockly.Msg, blocklyMsg);
    },
    
    loadToolBoxXml() {
      return new Promise((resolve, reject) => {
        let xhr = new XMLHttpRequest();
        let url = "" + process.env.BASE_URL + "static/xml/nuwa_toolbox.xml";
        xhr.open("GET", url);
        xhr.onreadystatechange = event => {
          if (xhr.readyState === 4 && xhr.status === 200) {
            if (/^\<xml/.test(xhr.responseText)) {
              resolve(xhr.responseText);
            } else {
              reject(event);
            }
          }
        };
        xhr.onerror = () => reject();
        xhr.send(null);
      });
    },
    handleUserInfo(data){
        data.userId = data.userId || data.studentId
        const {
            missionKeys,
            simulatorKeys,
        } = data
        exchangeutations.mission({ keys: missionKeys || [] })
        exchangeutations.simulator({ keys: simulatorKeys || [] })
        this.updateUserInfo(data)
    if(data.currentTeam && data.currentTeam.isRmsScope){
            //如果用戶當前有rms權限，獲取rms用戶信息
            this.updateRmsUserInfo()
        }
    },
    //更新rms用戶信息
    updateRmsUserInfo(){
        this.http$('get', '/rms/user/info', undefined, undefined, {
            Authorization: "Bearer " + this.token,
            customerid: this.teamId
        }).then(res => {
            if(res.data && res.data.data && res.data.data.payload){
                const data = res.data.data.payload
                this.$store.commit('groupTeamArr', data.groupResult)
            } else {
                console.error('get rms user info error:', res)
            }
        }).catch(err => {
            console.error('get rms user info error:', err)
        })
    },
    accountCenter () {
        if (this.currentVersion === 'student') {
            this.showAccountInfo = true
        }
    },
    afterLangChange(){
        if(this.projectData && this.projectData.script){
            window.localStorage.setItem('workSpaceData$', this.projectData.script)
        }
        window.location.reload()
    }
  }
};
</script>

<style lang="scss">
.code-lab {
  width: 100%;
  height: 100%;
  background: $--codelab-primary-black-1;
  &.has-header{
      padding-top: 60px;
      position: relative;
      .nuwa-app-header, .headerContainer{
          position: absolute;
          width: 100%;
          left: 0;
          top: 0;
          z-index: 1998;
          &.is-student{
            .nuwa-user-info{
                .user-info-popper .nuwa-dropdown-popper-wrapper ul{
                    .header-menu-item:nth-child(2){
                        display: none;
                    }
                }
            }
            .team-select{
                display: none;
            }
            .my-tools{
                display: none;
            }
        }
      }
  }
  .left-side {
    width: 64px;
    height: 100%;
    margin-top: 1px;
    margin-right: 1px;
    background: #333333;
    float: left;
  }
  .codelab-content {
    width: 100%;
    height: 100%;
    margin-top: 1px;
    float: left;
    .code-blockly {
      width: 100%;
      
      float: left;
    }
    .simulator-area {
      height: calc(100% - 46px);
      margin-left: -32px;
      pointer-events: none;
      float: left;
      z-index: 99;
    }
  }
  .program-area {
    height: calc(100% - 60px);
    position: fixed;
    top: 60px;
    background: $--codelab-primary-black-1;
    z-index: 100;
  }
}
.blocklyWidgetDiv {
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    background-color: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #cccccc;
  }
  ::-webkit-scrollbar-track {
    background-color: #999999;
  }
}
</style>

